<template lang="pug">
div.titleBaseForm 
    el-form(ref='form', :model='rowdata', label-width='160px')
        el-form-item(label='议题分类:') 
            el-input(size='mini', style='width:28%', disabled='', v-model='rowdata.consultTypeName')
            |       ~ 
            el-input(size='mini', style='width:28%', disabled='', v-model='rowdata.consultCutName')

        el-form-item(label='议题来源:')
            el-input(size='mini', style='width:50%', disabled='', v-model='reportSourceName')
        el-form-item(label='议题名称:')
            el-input(size='mini', style='width:50%', disabled='', v-model='rowdata.consultName')
        el-form-item(label='关键词:')
            el-input(size='mini', style='width:50%', disabled='', v-model='rowdata.keyWord')
        el-form-item(label='召开时间:')
            el-input(size='mini', style='width:50%', disabled='', v-model='rowdata.holdingTime')
        el-form-item(label='所属社区组织:', style='margin:0 30 0 0;')
            el-input(size='mini', style='width:28%', disabled='', v-model='rowdata.parentOrgName')
            |       ~ 
            el-input(size='mini', style='width:28%', disabled='', v-model='rowdata.orgName') 
                
        el-form-item(label='召开地点:')
            el-input(size='mini', style='width:50%', disabled='', v-model='rowdata.place')
        el-form-item(label='内容:', style='margin-bottom: 120px')
            quillEditor(v-model='rowdata.content', disabled='', :options='editorOption', style='height:150px')
            
        el-form-item(v-if='rowdata.enclosurePath', label='附件：', prop='enclosure')
            div(v-for='(item,index) in fileList', :key='index')
                a(:href='item.url', target='_blank') {{item.name}}
            el-upload(:file-list='fileList', action='', :disabled='true', :auto-upload='false', :on-preview='handlePreview')
        el-form-item(v-for="(item1,ind1) in addformTypeArr",:label='item1.consultName',  style='margin-top: 10px;')
            el-tag(v-for='tag in item1.datas', :key='tag.id',type="info")
                | {{tag.name}}（{{tag.phone}}）

        el-form-item(label='上架平台: ' )
            el-checkbox-group( v-model="publishPlatformCpt",disabled)
                el-checkbox(label='1') 公众号
                el-checkbox(label='2') app
                el-checkbox(label='3') web端
 
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import baseForm from "./baseForm.vue";
import editor_option from "../../../../utils/editorOption.js";
import request from "../../../../utils/request.js";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: "baseForm",
  props: ["fatherdata", "rowid"],
  components: {
    quillEditor,
    baseForm
  },
  data() {
    return {
      id: this.rowid,
      editorOption: editor_option.editorOption,
      rowdata: {
        representative: [],
        professional: [],
        organization: [],
        interestParty: [],
        someoneElse: [],
        responsible: [],
        assist: []
      },
      searchTypes1: [],
      searchTypes2: [],
      fileList: [],
      fileList2: [],
      selectOrgs1: [],
      selectOrgs2: [],
      addformTypeArr: []
    };
  },
  computed: {
    reportSourceName() {
      let v = "暂无";
      const reportSourceType = {
        1: "平台自建",
        2: "居民上报",
        3: "组织上报",
        4: "专家调研",
        5: "发函征集型"
      };
      if (this.fatherdata)
        return reportSourceType[this.fatherdata.reportSource];
      return v;
    },
    publishPlatformCpt() {
      if (this.fatherdata.publishPlatform)
        return this.fatherdata.publishPlatform.split(",");
      return [];
    }
  },
  methods: {
    //获取所属组织
    async getOrg(selVal) {
      let fd = new FormData();
      fd.append("token", token);
      //获取父类
      if (!selVal) {
        fd.append("parentId", 0);
        var res = await request({
          url: "/admin/consult/info/listOrg",
          method: "POST",
          data: fd
        });

        var temp = {};
        if (res.content && res.content.length > 0) {
          res.content.forEach(item => {
            temp = { id: item.id, value: item.id, label: item.orgName };
            this.selectOrgs1.push(temp);
          });
        }
      } else {
        //获取子组织
        fd.append("parentId", selVal);
        var res = await request({
          url: "/admin/consult/info/listOrg",
          method: "POST",
          data: fd
        });
        this.selectOrgs2 = [];
        var temp = {};

        if (res.content && res.content.length > 0) {
          this.allOrgs = res.content;
          res.content.forEach(item => {
            temp = { id: item.id, value: item.id, label: item.orgName };
            this.selectOrgs2.push(temp);
          });
        }
      }
    },

    //附件预览
    handlePreview(file) {
      window.open(file.url);
    },
    closeDialog() {
      this.id = "";
      this.$emit("func", []);
    },
    mergeObject(data) {
      let result = data.reduce((result, item) => {
        let index = result.findIndex(
          v => v.parentPersonTypeId === item.parentPersonTypeId
        );
        let { parentPersonTypeId, parentPersonTypeName, ...single } = item;
        if (index === -1) {
          result.push({
            parentPersonTypeId,
            consultName: parentPersonTypeName,
            datas: [single]
          });
        } else {
          result[index].datas.push(single);
        }
        return result;
      }, []);
      //   console.log(result);
      return result;
    },
    mergeObject2(data) {
      let result = data.reduce((result, item) => {
        let index = result.findIndex(
          v => v.parentPersonTypeId === item.parentPersonTypeId
        );
        let { parentPersonTypeId, parentPersonTypeName, ...single } = item;
        if (index === -1) {
          result.push({
            parentPersonTypeId,
            parentPersonTypeName,
            datas: [single]
          });
        } else {
          result[index].datas.push(single);
        }
        return result;
      }, []);
      //   console.log(result);
      return result;
    }
  },
  updated() {},
  mounted() {
    this.getOrg("");
  },
  beforeDestroy() {},
  watch: {
    fatherdata(val) {
      this.rowdata = val;

      this.fileList = [];
      var temp = {};
      if (val.enclosurePath != null && val.enclosurePath != "") {
        var namesArr = [];
        if (val.enclosureName != null && val.enclosureName != "") {
          namesArr = val.enclosureName.split(",");
        }
        var enclosureArr = val.enclosurePath.split(",");
        enclosureArr.forEach((item, index) => {
          if (item != "") {
            temp = {
              name: namesArr[index] ? namesArr[index] : "附件" + index,
              url: item
            };
            this.fileList.push(temp);
          }
        });
      }
      this.rowdata.representative = [];
      this.rowdata.professional = [];
      this.rowdata.organization = [];
      this.rowdata.interestParty = [];
      this.rowdata.someoneElse = [];
      this.addformTypeArr = [];
      //拆分persons人员关系字段
      if (this.rowdata.persons && this.rowdata.persons.length > 0) {
        // let newpersons = this.rowdata.persons.filter(
        //   it => it.parentPersonTypeId != 7 && it.parentPersonTypeId != 8
        // );
        this.addformTypeArr = this.mergeObject(this.rowdata.persons);
      }
    },

    rowid(val) {
      //   console.log(val);
      if (val) {
        this.id = val;
        this.getOrg();
      } else {
        this.rowdata = {
          representative: [],
          professional: [],
          organization: [],
          interestParty: [],
          someoneElse: [],
          responsible: [],
          assist: []
        };
      }
    }
  }
};
</script>
 